export const tr = {
    'avg-click-cost': 'Ortalama tıklama başına fiyat',
    'avg-click-cost-with-currency': 'Ortalama tıklama başına fiyat, {currency}',
    'avg-cpm-cost': 'Bin gösterim başına ortalama maliyet',
    'avg-cpm-cost-with-currency': 'Bin gösterim başına ortalama maliyet, {currency}',
    'avg-goal-cost': 'Ortalama dönüşüm fiyatı',
    'avg-goal-cost-with-currency': 'Ortalama dönüşüm fiyatı, {currency}',
    avgClickCost: 'CPC',
    avgGoalCost: 'CPA',
    'bounce-rate-with-percent': 'Hemen çıkma, %',
    bounceRate: 'Hemen çıkma',
    clicks: 'Tıklamalar',
    conversionRate: 'Dönüşümler, %',
    cost: 'Harcama',
    'cost-with-currency': 'Harcama, {currency}',
    ctr: 'CTR',
    'ctr-with-percent': 'CTR, %',
    goals: 'Dönüşümler',
    profitability: 'ROI',
    'profitability-words': 'Ortalama yatırım kârlılığı',
    revenue: 'Gelir',
    'revenue-with-currency': 'Gelir, {currency}',
    shows: 'Gösterimler'
};
